import { createContext, useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import ContextTypes from "../Interfaces/context.interface";
import { SelectorState } from "../Selectors/index.selector";
import * as authActions from '../Actions/Auth.action'
import { bindActionCreators } from "redux";
import { initialPermissions } from "../Constants/userPermission";
import { setSessionKindResolver, SessionKind } from "../Middleware/authErrorLink";

export const useAuth = () => useContext(AuthContext);

export const AuthContext = createContext({
  info: {
    _id: '',
    email: '',
    image: '',
    firstName: '',
    lastName: '',
    utilities: {
      country: '',
      city: '',
      currency: '',
      language: ''
    },
    store: {
      name: '',
      username: '',
      image: '',
      primaryColor: ''
    },
    type: '',
    permissions: initialPermissions
  },
  linfo: {} as boolean,
  offline: false
});

export const AuthProvider = ({children} :ContextTypes["childrenProps"]) => {
  const dispatch = useDispatch();
  const { info, linfo } = useSelector((state :SelectorState) => state.Auth);
  const { getInfo, getInfoDriver } = bindActionCreators(authActions, dispatch);
  const [offline, setOffline] = useState(false);
  const driver = localStorage.getItem("typename");

  useEffect(() => {
    if(!info && !linfo){
      if(driver && driver === "Driver") {
        getInfoDriver();
      } else {
        getInfo();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[info]);

  // Register the session kind with the auth middleware so it picks the
  // correct refresh endpoint (refreshAdmin vs refreshDriver). Admins
  // carry `info.email`; drivers do not.
  useEffect(() => {
    setSessionKindResolver((): SessionKind => {
      if (!info?._id) return null;
      return info.email ? 'admin' : 'driver';
    });
  }, [info]);

  useEffect(()=> {
    if(!navigator.onLine){
      setOffline(true);
    } else {
      setOffline(false)
    }
  },[])
  
    return (
      <AuthContext.Provider value={{info, linfo, offline}}>
          {children}
      </AuthContext.Provider>
    );
  }